/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentFarmerAccount } from '../../../azure-b2c/storage';
import { getNutritionPromoInfo, selectPromoEnabled } from '../../../nutrition-promo/storage';

import PromoBanner from '../../../../assets/images/PromoBanner.png';
import PromoText from '../../../../assets/images/PromoText.png';
import FieldDaysNZ from '../../../../assets/images/FieldDaysNZ.png';
import NutritionDeals from '../../../../assets/images/NutritionDeals.png';
import { Button } from '../../../../components/Button';
import { Box, Stack, styled, useMediaQuery, useTheme } from '@mui/material';
import PromoModal from '../../../nutrition-promo/components/PromoModal';
import { useAppDispatch } from '../../../../store/rootStore';
import { farmlandsMuiTheme } from '../../../../theme/farmlands-mui-theme';

const DesktopPromo = styled('img')`
  height: 52px;
  width: 548px;

  @media (max-width: ${farmlandsMuiTheme().breakpoints.values.sm + 75}px) {
    width: 480px;
    height: 48px;
  }
`;

export const NutritionPromo = () => {
  const nutritionPromoEnabled = useSelector(selectPromoEnabled);
  const account = useSelector(selectCurrentFarmerAccount);

  const [promoOpen, setPromoOpen] = useState(false);

  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (account) {
      dispatch(getNutritionPromoInfo());
    }
  }, []);

  const nutritionPromo = React.useMemo(() => {
    return account?.hasCheckoutAccess && nutritionPromoEnabled;
  }, [account, nutritionPromoEnabled]);

  if (!nutritionPromo) return;
  return (
    <>
      <Box
        display='flex'
        height='204px'
        sx={{
          background: `url(${PromoBanner})`,
          backgroundPosition: '-140px -374.78px / 126.897% 388.276% no-repeat',
        }}
        onClick={() => setPromoOpen(true)}
      >
        <Box
          sx={{
            width: '100%',
            background: 'linear-gradient(271deg, rgba(0, 85, 61, 0.00) 4.44%, #00553D 102.54%)',
          }}
        >
          <Stack
            spacing={2}
            sx={{
              width: '100%',
              height: '100%',
              background: `radial-gradient(100% 214.69% at 2.45% 28.19%, #00553D 0%, rgba(0, 85, 61, 0.00) 100%)`,
              padding: '32px',
            }}
          >
            {!isSm ? (
              <DesktopPromo src={PromoText} width='548px' height='52px' />
            ) : (
              <Stack spacing={0} flexWrap='wrap'>
                <img alt='Field Days NZ' src={FieldDaysNZ} width='135px' height='33.4px' />
                <img alt='Nutrition Deals' src={NutritionDeals} width='211px' height='33.4px' />
              </Stack>
            )}
            <Box>
              <Button color='tertiary' variant='outlined'>
                See offers
              </Button>
            </Box>
          </Stack>
        </Box>
      </Box>
      <PromoModal open={promoOpen} handleClose={() => setPromoOpen(false)} />
    </>
  );
};
